// CarouselIndicator.styles.ts
import styled from "@emotion/styled";
import { SvgWrapperProps } from "./CarouselIndicator.types";

// Main container for the indicator
export const IndicatorContainer = styled.div<{
  width: number;
  height: number;
  color: string;
}>`
  border-radius: 9999999px;
  box-shadow: ${({ color }) => `0 0 0 1px ${color} inset`};
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
  box-sizing: content-box;
  position: relative;
  overflow: hidden; /* Add overflow hidden to prevent children from overflowing */
  div {
    left: 0;
    position: absolute;
    box-sizing: content-box;
    box-shadow: ${({ color }) => `0 0 0 1px ${color} inset`};
    border-radius: 9999999px;
    transition: transform 0.3s ease; /* Add smooth transition */
    height: 100%;
  }
  div:last-of-type {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

// Wrapper for the SVG (with rotation)
export const SvgWrapper = styled.span<SvgWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ percent = 0 }) => `rotate(${(percent / 100) * 360}deg)`};
  transition: transform 0.3s ease;
`;
export const StyledDiv = styled.div<{ width: string; transform: string }>`
  width: ${({ width }) => width};
  transform: ${({ transform }) => transform};
`;
